// @flow
import React from "react";
import {connect} from "react-redux";
import FreeSelectionTop from "./FreeSelectionTop/FreeSelectionTop";
import FreeSelectionBottom from "./FreeSelectionBottom/FreeSelectionBottom";
import FreeSelectionFloatingPin from "./FreeSelectionFloatingPin/FreeSelectionFloatingPin";
import MapDataSelectors from "../../../../Store/Ducks/MapData/selectors";
import Screens from "../../../../Store/Views/screens";


const FreeSelection = props => {
    return ([
        <FreeSelectionTop key="free selection top"/>,
        <FreeSelectionFloatingPin
            key="free selection floating pin"
            inZone={props.inZone}
            isOrigin={props.isOrigin}
            isDest={props.isDest}/>,
        <FreeSelectionBottom
            key="free selection bottom"
            inZone={props.inZone}
            isOrigin={props.isOrigin}
            isDest={props.isDest}/>,
    ]);
};

const mapStateToProps = state => {
    return {
        inZone: MapDataSelectors.isMapCenterInZone(state),
        isOrigin: Screens.shouldShowSelectOrigin(state),
        isDest: Screens.shouldShowSelectDest(state),
    };
};

export default connect(mapStateToProps)(FreeSelection);


// WEBPACK FOOTER //
// ./src/Components/Screen/RideRequest/FreeSelection/FreeSelection.js